var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConhectaLogoMobile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 292,
    height: 425,
    viewBox: "0 0 292 425",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.3154 151.439H52.9232V170.814L53.3862 171.312C57.4821 164.011 62.86 158.277 69.5202 154.11C76.1804 149.943 83.5172 147.877 91.602 147.877C105.029 147.877 115.643 151.617 123.407 159.096C131.136 166.575 135.018 177.794 135.018 192.753V283.288H107.985V200.375C107.665 190.01 105.599 182.496 101.824 177.794C98.0129 173.129 92.1007 170.778 84.0159 170.778C79.4214 170.778 75.3256 171.668 71.6928 173.449C68.06 175.23 64.9614 177.687 62.4326 180.857C59.9039 183.991 57.9094 187.695 56.4848 191.969C55.0602 196.208 54.3479 200.731 54.3479 205.503V254.447C54.3479 254.447 54.121 249.057 48.1972 245.986C42.2734 242.914 27.3154 242.42 27.3154 242.42V151.403V151.439Z",
    fill: "#0D69B1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M168.246 101.186H195.279V168.784H195.742C199.054 162.837 204.004 157.85 210.558 153.861C217.111 149.872 224.448 147.878 232.497 147.878C245.924 147.878 256.538 151.618 264.302 159.097C272.031 166.576 275.913 177.795 275.913 192.754V248.904C275.913 248.904 272.84 244.009 265.497 242.727C258.154 241.445 248.88 243.776 248.88 243.776V200.376C248.56 190.011 246.494 182.497 242.719 177.795C238.908 173.13 232.996 170.779 224.911 170.779C220.316 170.779 216.221 171.669 212.588 173.45C208.955 175.231 205.856 177.688 203.328 180.858C200.799 183.992 198.804 187.696 197.38 191.97C195.955 196.209 195.243 200.732 195.243 205.504V283.289H168.21V101.186H168.246Z",
    fill: "#0D69B1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4678 120.346L145.309 13.0352L281.113 120.346",
    stroke: "#0D69B1",
    strokeWidth: 20.4079,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M139.505 417.066C139.505 417.066 141.998 380.275 136.513 370.338C131.029 360.402 74.898 317.164 62.4681 314.671C50.0381 312.178 40.1013 320.619 38.6055 330.092L75.8953 365.637",
    stroke: "#0D69B1",
    strokeWidth: 8.90396,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M83.3391 420.521C83.3391 420.521 77.3912 401.146 47.5451 378.281C17.7347 355.415 16.2388 367.952 14.2443 314.243C12.2498 260.534 13.247 241.622 46.5479 252.557L46.0492 311.679",
    stroke: "#0D69B1",
    strokeWidth: 8.90396,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5039 263.49C48.5039 263.49 62.4653 261.496 66.9529 266.981C71.4405 272.466 66.9529 311.216 66.9529 311.216",
    stroke: "#0D69B1",
    strokeWidth: 8.90396,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M72.9033 279.874C72.9033 279.874 88.3606 277.879 89.3222 283.863C90.2839 289.846 87.2921 317.164 87.2921 317.164",
    stroke: "#0D69B1",
    strokeWidth: 8.90396,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M152.077 416.246C152.077 416.246 149.584 379.455 155.069 369.518C160.554 359.581 216.684 316.344 229.114 313.85C241.544 311.357 251.481 319.798 252.977 329.272L215.687 364.817",
    stroke: "#0D69B1",
    strokeWidth: 8.90396,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M208.205 419.739C208.205 419.739 214.153 400.364 243.999 377.498C273.809 354.633 275.305 367.17 277.3 313.461C279.294 259.717 278.297 240.84 244.996 251.774L245.495 310.897",
    stroke: "#0D69B1",
    strokeWidth: 8.90396,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M243.076 262.707C243.076 262.707 229.115 260.713 224.627 266.197C220.14 271.682 224.627 310.432 224.627 310.432",
    stroke: "#0D69B1",
    strokeWidth: 8.90396,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M218.68 279.091C218.68 279.091 203.222 277.096 202.261 283.08C201.299 289.063 204.291 316.38 204.291 316.38",
    stroke: "#0D69B1",
    strokeWidth: 8.90396,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConhectaLogoMobile);
export default __webpack_public_path__ + "static/media/conhecta_logo_mobile.05e5213d7d560bf2c1d78a7d53965428.svg";
export { ForwardRef as ReactComponent };